import type { StoreJsonResponse } from "@/stores/common/store.core";
import { Store } from "@/stores/common/store.core";
import type {
   DeleteSessionCurrentResponse,
   DeleteSessionResponse,
   GetSessionCurrentResponse,
   SetSessionCurrentResponse,
} from "@laborchart-modules/lc-core-api/dist/api/sessions/";

export abstract class SessionStore {
   static deleteCurrentSession(): StoreJsonResponse<DeleteSessionCurrentResponse> {
      return Store.requestJson({
         url: "/api/v3/sessions/current",
         method: "DELETE",
      });
   }

   static deleteAllSessions(): StoreJsonResponse<DeleteSessionResponse> {
      return Store.requestJson({
         url: "/api/v3/sessions",
         method: "DELETE",
      });
   }

   static getCurrentSession(): StoreJsonResponse<GetSessionCurrentResponse> {
      return Store.requestJson({
         url: "/api/v3/sessions/current",
         method: "GET",
      });
   }

   static renewSession(
      authingWithProcore: boolean = false,
   ): StoreJsonResponse<SetSessionCurrentResponse> {
      return Store.requestJson({
         url: "/api/v3/sessions/current",
         maxRetryCount: 0,
         method: "PUT",
         body: {
            authing_with_procore: authingWithProcore,
         },
      });
   }
}
